if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.showOnScroll = this.dataset.showOnScroll === 'true';
        this.variantUnsubscriber = undefined;
      }

      connectedCallback() {
        this.initElements();
        this.bindEvents();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.sectionId && event.data.variant) {
              this.onVariantChangeFromMain(event.data.variant);
            }
          });
        }

        if (this.showOnScroll) {
          this.initScrollObserver();
        }
      }

      disconnectedCallback() {
        if (this.variantUnsubscriber) {
          this.variantUnsubscriber();
        }
        if (this.observer && this.mainSubmitButton) {
          this.observer.unobserve(this.mainSubmitButton);
        }
        if (this.onScrollHandler) {
          window.removeEventListener('scroll', this.onScrollHandler);
        }
      }

      initElements() {
        this.variantSelect = this.querySelector('.sticky-add-to-cart__variant-select');
        this.quantityInput = this.querySelector('.sticky-add-to-cart__quantity-input');
        this.quantityMinusBtn = this.querySelector('.sticky-add-to-cart__quantity button[name="minus"]');
        this.quantityPlusBtn = this.querySelector('.sticky-add-to-cart__quantity button[name="plus"]');
        this.submitButton = this.querySelector('.sticky-add-to-cart__button');
        this.buttonText = this.querySelector('.sticky-add-to-cart__button-text');

        // Main page elements
        this.mainProductForm = document.getElementById(`product-form-${this.sectionId}`);
        this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainVariantInput = this.mainProductForm ? this.mainProductForm.querySelector('input[name="id"]') : null;
        this.mainQuantityInput = document.getElementById(`Quantity-${this.sectionId}`);
      }

      bindEvents() {
        // Dropdown selection change
        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', this.onStickyVariantChange.bind(this));
        }

        // Quantity input changes
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', this.onQuantityChange.bind(this));
        }

        if (this.quantityMinusBtn) {
          this.quantityMinusBtn.addEventListener('click', () => {
            setTimeout(() => this.onQuantityChange(), 50);
          });
        }

        if (this.quantityPlusBtn) {
          this.quantityPlusBtn.addEventListener('click', () => {
            setTimeout(() => this.onQuantityChange(), 50);
          });
        }

        // Submit button click -> trigger main submit button
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmit.bind(this));
        }
      }

      onStickyVariantChange() {
        if (!this.variantSelect) return;
        const selectedVariantId = this.variantSelect.value;
        const selectedOption = this.variantSelect.options[this.variantSelect.selectedIndex];

        // 1. Update main product form hidden variant ID input
        if (this.mainVariantInput) {
          this.mainVariantInput.value = selectedVariantId;
          this.mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 2. If main variant picker (radios / selects) exists, sync option values
        const mainVariantSelects = document.getElementById(`variant-selects-${this.sectionId}`);
        const mainVariantRadios = document.getElementById(`variant-radios-${this.sectionId}`);

        if (mainVariantSelects || mainVariantRadios) {
          const pickerContainer = mainVariantSelects || mainVariantRadios;
          const variantDataScript = pickerContainer.querySelector('script[type="application/json"]');
          if (variantDataScript) {
            try {
              const variantData = JSON.parse(variantDataScript.textContent);
              const targetVariant = variantData.find((v) => v.id.toString() === selectedVariantId.toString());
              if (targetVariant) {
                // Update select dropdowns or radio inputs in main picker
                targetVariant.options.forEach((optionValue, index) => {
                  const optionIndex = index + 1;
                  if (mainVariantSelects) {
                    const select = mainVariantSelects.querySelector(`select[name*="options["]:nth-of-type(${optionIndex})`) || mainVariantSelects.querySelectorAll('select')[index];
                    if (select) {
                      select.value = optionValue;
                      select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                  if (mainVariantRadios) {
                    const radio = mainVariantRadios.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`);
                    if (radio) {
                      radio.checked = true;
                      radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                });
              }
            } catch (e) {
              console.error('Error syncing variant picker:', e);
            }
          }
        }

        // 3. Update sticky button availability state
        const isAvailable = selectedOption && selectedOption.dataset.available === 'true';
        this.updateButtonState(isAvailable);
      }

      onQuantityChange() {
        if (!this.quantityInput) return;
        const currentQty = this.quantityInput.value;

        if (this.mainQuantityInput) {
          this.mainQuantityInput.value = currentQty;
          this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onVariantChangeFromMain(variant) {
        if (!variant) return;

        // Update sticky dropdown selection
        if (this.variantSelect) {
          this.variantSelect.value = variant.id;
        }

        // Update button state
        this.updateButtonState(variant.available);
      }

      updateButtonState(isAvailable) {
        if (!this.submitButton) return;

        if (isAvailable) {
          this.submitButton.removeAttribute('disabled');
          if (this.buttonText) {
            const customText = this.dataset.customText;
            this.buttonText.textContent = customText && customText.trim() !== ''
              ? customText
              : (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
          }
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.buttonText) {
            this.buttonText.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
          }
        }
      }

      onSubmit(e) {
        e.preventDefault();

        // Check if main submit button exists and click it
        if (!this.mainSubmitButton) {
          this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        }

        if (this.mainSubmitButton) {
          // Sync quantity first
          if (this.quantityInput && this.mainQuantityInput) {
            this.mainQuantityInput.value = this.quantityInput.value;
          }

          // Trigger main button click to fire Dawn's AJAX product form handling
          this.mainSubmitButton.click();
        } else if (this.mainProductForm) {
          this.mainProductForm.submit();
        }
      }

      initScrollObserver() {
        if (!this.mainSubmitButton) {
          this.mainSubmitButton =
            document.getElementById(`ProductSubmitButton-${this.sectionId}`) ||
            document.querySelector('.product-form__submit');
        }

        if (!this.mainSubmitButton) return;

        // Hide initially until scroll position is determined
        this.classList.add('sticky-add-to-cart--hidden');

        const handleVisibility = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Main button is currently visible on product page -> hide sticky bar
              this.classList.add('sticky-add-to-cart--hidden');
            } else {
              // Main button is not in viewport: check if user has scrolled past it
              if (entry.boundingClientRect.top < 0) {
                this.classList.remove('sticky-add-to-cart--hidden');
              } else {
                // Button is below viewport (e.g. initial top of page) -> hide sticky bar
                this.classList.add('sticky-add-to-cart--hidden');
              }
            }
          });
        };

        this.observer = new IntersectionObserver(handleVisibility, {
          rootMargin: '0px',
          threshold: 0
        });

        this.observer.observe(this.mainSubmitButton);

        // Fallback check on scroll/resize in case layout shifts
        this.onScrollHandler = () => {
          if (!this.mainSubmitButton) return;
          const rect = this.mainSubmitButton.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
          const isScrolledPast = rect.bottom < 0;

          if (!isVisible && isScrolledPast) {
            this.classList.remove('sticky-add-to-cart--hidden');
          } else {
            this.classList.add('sticky-add-to-cart--hidden');
          }
        };

        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        // Initial check after paint
        requestAnimationFrame(() => this.onScrollHandler());
      }
    }
  );
}
